import { render, staticRenderFns } from "./TemplatesViewer.vue?vue&type=template&id=0fe30dae&scoped=true&"
import script from "./TemplatesViewer.vue?vue&type=script&lang=js&"
export * from "./TemplatesViewer.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesViewer.vue?vue&type=style&index=0&id=0fe30dae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe30dae",
  null
  
)

export default component.exports